module.exports = __webpack_public_path__ + "img/empty.14b14178.png";